import { useState } from "react"
import { Listbox, Transition } from "@headlessui/react"
import { ChevronDownIcon } from "@heroicons/react/24/outline"
import classNames from "classnames"

import DefaultOption from "./DefaultOption"

export default function SelectMenu({
  buttonClasses,
  listClasses,
  handleSelectChange,
  selectedValue,
  options,
  isMultiSelect,
  renderOption,
  placeholder,
}) {
  const [isOpen, setIsOpen] = useState(false)

  const selectClasses = classNames("h-full w-full", {
    "z-50": isOpen,
  })

  const btnClasses = classNames(
    "flex h-full w-full items-center justify-around px-2",
    buttonClasses
  )

  const optionsListClasses = classNames(
    "focus:outline-none",
    {
      "rounded-md border bg-white": !listClasses,
    },
    listClasses
  )

  function getDisplayValue() {
    if (selectedValue) {
      return isMultiSelect
        ? `${selectedValue.map((v) => v.label).join(", ")}`
        : `${selectedValue.label}`
    }

    if (placeholder) {
      return placeholder
    }

    const defaultPlaceholder = isMultiSelect
      ? "Select values..."
      : "Select a value..."

    return defaultPlaceholder
  }

  return (
    <Listbox
      as="div"
      className={selectClasses}
      value={selectedValue}
      onChange={handleSelectChange}
      open={isOpen}
      multiple={isMultiSelect}
    >
      <Listbox.Button
        onClick={() => setIsOpen((prev) => !prev)}
        className={btnClasses}
        data-testid="select-button"
      >
        <span>{getDisplayValue()}</span>
        <ChevronDownIcon className="ml-auto h-3 w-3" />
      </Listbox.Button>
      <Transition
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
        className="relative z-40 mt-px w-full"
      >
        <Listbox.Options
          data-testid="select-options-list"
          className={optionsListClasses}
        >
          {options.map((option, index) => {
            return (
              <Listbox.Option
                key={index}
                value={option}
                data-testid={`select-option-${option.value}`}
              >
                {({ selected: isSelected, active: isActive }) => (
                  <>
                    {renderOption ? (
                      renderOption({
                        option,
                        selectedValue,
                        isSelected,
                        isActive,
                      })
                    ) : (
                      <DefaultOption
                        option={option}
                        isActive={isActive}
                        isSelected={isSelected}
                      />
                    )}
                  </>
                )}
              </Listbox.Option>
            )
          })}
        </Listbox.Options>
      </Transition>
    </Listbox>
  )
}
